import { Component, OnInit } from '@angular/core';
import { Entity } from '../entity';
import { EntityService } from '../entity.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-entity-list',
  templateUrl: './entity-list.component.html',
  styleUrls: ['./entity-list.component.css']
})
export class EntityListComponent implements OnInit {


  SerchText:string ='';
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  entity = new Entity();  //Po is defined from abobe import po
  entities: Entity[];
  totalrecord:number;
  message: string;	
  entityFilter: any = { entityname: '' };
  constructor(
	private entityService: EntityService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
  ) { }

  ngOnInit() {
    this.getEntitys();
  }

  getEntitys() {
    this.spinnerService.show();
    return this.entityService.getEntitylist()
               .subscribe(
                entities => {
                  console.log(entities);
                  this.entities = entities
          this.totalrecord = this.entities.length;
          this.spinnerService.hide();
                 }
                );
 }
 delete(entityid): void {
  //this.submitted = true;
  this.entityService.deleteEntity(entityid)
      .subscribe(()=> this.message = "Entity Deleted Successfully!");
  this.getEntitys();   
}


public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}
}
